import type { QueueCounts, QueueStatus } from "../api/types";

// Filtro a 4 stati per le code output (RDI + DDT), coda-in-lavorazione:
// "in lavorazione" e' il messaggio che il consumer del cliente ha ricevuto
// (in lease) ma non ancora confermato con una delete — invisibile nella
// coda Azure, quindi anche nella vista di default "Da prelevare". "Prelevato"
// resta: messaggio non piu' in coda (lo marca il reconciler dopo la delete).
const OPTIONS: { value: QueueStatus; label: string }[] = [
  { value: "pending", label: "Da prelevare" },
  { value: "in_lease", label: "In lavorazione" },
  { value: "picked_up", label: "Prelevati" },
  { value: "all", label: "Tutti" },
];

// Etichetta per il conteggio ("N da prelevare" / "N in lavorazione" / ...).
export const QUEUE_STATUS_LABEL: Record<QueueStatus, string> = {
  pending: "da prelevare",
  in_lease: "in lavorazione",
  picked_up: "prelevati",
  all: "in totale (inviati)",
};

export function QueueStatusFilter({
  value,
  onChange,
  counts,
}: {
  value: QueueStatus;
  onChange: (status: QueueStatus) => void;
  /** Conteggi per stato. Facoltativo: quando presente, il bottone "In
   *  lavorazione" mostra il numero (`counts.in_lease`) cosi' l'operatore
   *  vede quante pratiche sono in lease senza doverci cliccare sopra prima.
   *  Un server non ancora aggiornato non li manda: l'etichetta resta senza
   *  numero, come le altre. */
  counts?: QueueCounts;
}) {
  return (
    <div style={{ display: "flex", gap: "var(--space-1)", flexWrap: "wrap" }}
      role="group" aria-label="Filtro stato coda">
      {OPTIONS.map((opt) => {
        const label = opt.value === "in_lease" && counts
          ? `${opt.label} (${counts.in_lease})`
          : opt.label;
        return (
          <button key={opt.value} type="button"
            className={`btn btn-sm ${value === opt.value ? "btn-primary" : "btn-outline"}`}
            aria-pressed={value === opt.value}
            onClick={() => onChange(opt.value)}>
            {label}
          </button>
        );
      })}
    </div>
  );
}
